import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { AppRoutingModule } from "./app-routing.module";
import { AppCommonModule } from "./common/app-common.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideNgxWebstorage, withLocalStorage, withSessionStorage } from "ngx-webstorage";
import { providePrimeNG } from "primeng/config";
import { primeNgTheme } from "./primeng-theme";
import { MatSidenavModule } from "@angular/material/sidenav";
import { ManageUsersComponent } from "./bas/users/manage-users/manage-users.component";
import { UsersLayoutComponent } from "./bas/users/users-layout/users-layout.component";
import { NgxPaginationModule } from "ngx-pagination";
import { SortnamePipe } from "./sortname.pipe";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatCardModule } from "@angular/material/card";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ApprovalsV2Component } from "./bas/dashboard/approvals-v2/approvals-v2.component";

@NgModule({ declarations: [AppComponent, SortnamePipe],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        NgSelectModule,
        AppCommonModule,
        NgxPaginationModule,
        MatSidenavModule,
        MatCardModule,
        NgbModule,
        MatProgressBarModule,
        NgxSkeletonLoaderModule.forRoot()], providers: [
        ApprovalsV2Component,
        ManageUsersComponent,
        UsersLayoutComponent,
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
        providePrimeNG({ theme: primeNgTheme }),
    ] })
export class AppModule {}
